import groupBy from 'lodash/groupBy'
import { IFlatMetadata } from 'react-accessible-treeview/dist/TreeView/utils'
import { ControlledExpandedNode, ITreeNode } from '../../tree-view/TreeView'
import { useReviewHistory } from './hooks'

interface ReviewHistoryProps {
  title: string
}

export function ReviewHistory({ title }: ReviewHistoryProps) {
  const reviewItems = useReviewHistory()

  return (
    <div className='review-history w-full'>
      <h2 className='text-lg font-semibold mb-2'>{title}</h2>
      <div className='review-content'>
        <ControlledExpandedNode
          node={
            reviewItems.length
              ? {
                  name: '',
                  children: reviewItems.reverse().map(item => {
                    let children = [
                      { name: ' No inline comments', children: [] }
                    ] as ITreeNode<IFlatMetadata>[]
                    if (
                      Array.isArray(item.review.diffComments) &&
                      item.review.diffComments.length > 0
                    ) {
                      const inlineComments = groupBy(item.review.diffComments, 'filePath')
                      children = Object.keys(inlineComments).map(filePath => {
                        return {
                          name: filePath || 'No file path',
                          children: inlineComments[filePath].map(comment => {
                            return {
                              name: `${comment.startLineNumber}-${comment.endLineNumber}: ${comment.comment}`,
                              children: []
                            }
                          })
                        }
                      }) as unknown as ITreeNode<IFlatMetadata>[]
                    }
                    return {
                      name: item.review.generalDiffComment || 'No general comment',
                      children
                    }
                  })
                }
              : null
          }
        />
      </div>
    </div>
  )
}
